// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bek_a bhh_tp","StrollerBoxWidget__imageCounselling":"bek_b bhh_ke"};